// extracted by mini-css-extract-plugin
export default {"whatIsPCP":"styles_whatIsPCP__B7eNQ","twoCols":"styles_twoCols__5MACy","textContent":"styles_textContent__xKUyt","imgContent":"styles_imgContent__sOd29"};